module.exports = __webpack_public_path__ + "img/yacht-3.b2699956.jpg";